var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoCrm24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_crm24x24",
    transform: "translate(-2.995 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(2.995 3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M.02,2.157A2.139,2.139,0,0,1,4.27,1.81a3.536,3.536,0,0,1,3.318.946l.123.124L6.13,4.46l-.123-.123A1.315,1.315,0,0,0,4.151,6.2l.309.309,1.581,1.58,1.67,1.671L6.13,11.34,4.459,9.667,2.881,8.088l-.3-.309a3.552,3.552,0,0,1-.888-3.531A2.143,2.143,0,0,1,.02,2.157ZM4.647,6.319,6.226,7.9,7.9,6.23,9.476,4.65l.308-.309A1.311,1.311,0,1,1,11.639,6.2l-.122.123L13.095,7.9l.123-.124a3.553,3.553,0,0,0,.9-3.494,2.143,2.143,0,1,0-2.4-2.42,3.542,3.542,0,0,0-3.511.9L7.9,3.068,6.318,4.647Zm9.507,5.428A3.548,3.548,0,0,0,13.215,8.4l-.31-.311-1.578-1.58L9.662,4.835,8.085,6.416,9.751,8.087l1.578,1.581.308.31a1.313,1.313,0,0,1-1.854,1.859l-.122-.121L8.085,13.3l.121.12a3.543,3.543,0,0,0,3.554.883,2.14,2.14,0,1,0,2.4-2.549ZM11.142,9.854,9.563,8.277,7.9,9.946l-1.578,1.58-.308.31A1.315,1.315,0,1,1,4.151,9.975l.123-.121L2.694,8.277l-.118.117a3.552,3.552,0,0,0-.931,3.389A2.143,2.143,0,1,0,4.221,14.35a3.539,3.539,0,0,0,3.364-.933l.309-.311,1.577-1.582Z",
    transform: "translate(.005 -.014)",
    fill: "#999"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoCrm24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_crm24x24.4152f6441bac56647f6cb7b8357da82e.svg";